export function lazy<T>(callback: () => T): () => T {
  let value: T | undefined = undefined;

  return () => {
    if (value === undefined) {
      value = callback();
    }

    return value;
  };
}
